"use client";

import { AppErrorState } from "@/components/ui/app-error-state";

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <AppErrorState error={error} reset={reset} boundary="legal" />;
}
